import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const ViewButton = styled('button')`
   width: 40px;
   height: 40px;
   left: -20px;
   text-align: center;
   font-size: 16px;
   line-height: 18px;
   cursor: pointer;
   transition: all .25s;
   outline: none;
   background: none;
   border: none;
   border-radius: 100px;
   border: 1px solid #ddd;
   color: #ccc;
   background-color: #fff;
   padding: 2px;
   transform: ${props => props.active ?
    props.above ? 'rotate(-90deg)' : 'rotate(90deg)' : ''};
   &:hover {
     color: ${props => !props.active ? 'orange' : ''};
   }
   pointer-events: ${props => props.active ? 'none' : 'default'};
   i {
     margin-top: 3px;
     margin-left: 4px;
     font-size: 21px;
   }
 `;

export default ViewButton;
